export default {
    methods: {
       /**
     * Metodo di ingresso al drawer
     */
        GoogleMapDrawer_startDrawing(option) {
        let self = this;
       
        // Risolvo la promise di disegno della mappa di gmap
        this.$refs.gmap.$mapPromise.then(mapObject => {
          // Modifico la posizione dei bottoni
          this.mapOptions = {
              zoomControlOptions: {
                  position: google.maps.ControlPosition.LEFT_BOTTOM
              },
              styles: option.stylemap

          }

          // Storo l'istanza di google map
          this.map = mapObject;

          // Stanzio e assegno ad una variabile il DrawerManager
          const drawingManager = new google.maps.drawing.DrawingManager({
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_CENTER,
              drawingModes: ["circle", "polygon"]
            },
            // Setto gli stili di default delle varie forme
            polygonOptions: self.shapeStyle,
            circleOptions: self.shapeStyle
          });

          this.drawingManager = drawingManager;

          // Applico il drawer alla mappa
          drawingManager.setMap(this.$refs.gmap.$mapObject);

          // Evento scatenato al disegno di un cerchio
          drawingManager.addListener("circlecomplete", function(_circle) {
            // Svuoto datalayer
            self.emptyDataLayer();
            // Setto il punto corrente
            self.points = new google.maps.Data.Point(_circle.getCenter());

              // Setto il cerchio currente
             self.currentCircle.push(_circle);

              // Aggiungo la forma al datalayer
              mapObject.data.add(
                  new google.maps.Data.Feature({
                      properties: {
                          radius: _circle.getRadius()
                      },
                      geometry: self.points
                  })
              );
          });

          // Evento scatenato al disegno di un poligono
          drawingManager.addListener("polygoncomplete", function(_polygon) {
              // Setto il poligono currente
              self.currentPolygon.push(_polygon);

              // Aggiungo la forma al datalayer
              mapObject.data.add(
                  new google.maps.Data.Feature({
                      geometry: new google.maps.Data.Polygon([
                          _polygon.getPath().getArray()
                      ])
                  })
              );
          });

          // Listener sul generico completamento di un disegno
          drawingManager.addListener("overlaycomplete", function(event) {
              // Svuoto datalayer
              self.emptyDataLayer();
              self.zoneSelected = null;
              // Creo il GeoJson da inviare alla ricerca
              self.createGeoJson(mapObject);
          });


          // Evento al caricamento della mappa
          google.maps.event.addListener(mapObject, "tilesloaded", function() {

            if(self.firstload) {
            // Ridisegno i bottoni
            self.GoogleMapDrawerButtons_redrawButtonsTools();

            }
            self.firstload = false;

          });
        });

       
        },

        /**
         * Setto il colore dei poligoni
         */
        GoogleMapDrawer_setColor(mapObject, colors) {
            mapObject.data.setStyle(function(feature) {
                let color = colors.secondary;
                let strokecolor = colors.secondary;
                if (feature.getProperty('isColorful')) {
                    color = feature.getProperty('color');
                }
                return /** @type {!google.maps.Data.StyleOptions} */({
                    fillColor: color,
                    fillOpacity: 0.3,
                    strokeColor: strokecolor,
                    strokeWeight: 1,
                });
            });
        },

        /**
         * Aggiungo il marker
         * @param {*} res
         * @param {*} mapObject
         */
        GoogleMapDrawer_addMarker(res, mapObject) {
            var marker, i;

            res.each((element) => {
                if (location != null) {
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(element.location.lat, element.location.lng),
                        map: mapObject,
                        customInfo: res[i]
                    });

                    this.markers.push(marker);
                }

            });
        },

        /**
         * Metodo di gestione eventi click sulla drawingbar
         */
        drawerButtonActive() {

        }
    }
 }
